import React from "react";
import { LoadingButton } from "@atlaskit/button";
import VidPauseIcon from "@atlaskit/icon/glyph/vid-pause";
import VidPlayIcon from "@atlaskit/icon/glyph/vid-play";
import SelectClearIcon from "@atlaskit/icon/glyph/select-clear";
import { Separator } from "@atlassiansox/microscopekit";
import { ScheduleStatus } from "../../__generated__/graphql-global-types";
import pauseScheduleMutation from "../graphql/wargame-pause-schedule.mutation.graphql";
import resumeScheduleMutation from "../graphql/wargame-resume-schedule.mutation.graphql";
import cancelScheduleMutation from "../graphql/wargame-cancel-schedule.mutation.graphql";
import { useMutationUI } from "../hooks";
export function WargameScheduleTableActions(_a) {
    var _b;
    var wargameSchedule = _a.wargameSchedule;
    var mutationOptions = { variables: { id: (_b = wargameSchedule.id) !== null && _b !== void 0 ? _b : "" } };
    var _c = useMutationUI({
        mutation: pauseScheduleMutation,
        options: mutationOptions,
        successMessage: createSuccessMessage(wargameSchedule, "paused")
    }), isPauseScheduleLoading = _c.isLoading, pauseSchedule = _c.mutate;
    var _d = useMutationUI({
        mutation: resumeScheduleMutation,
        options: mutationOptions,
        successMessage: createSuccessMessage(wargameSchedule, "resumed")
    }), isResumeScheduleLoading = _d.isLoading, resumeSchedule = _d.mutate;
    var _e = useMutationUI({
        mutation: cancelScheduleMutation,
        options: mutationOptions,
        successMessage: createSuccessMessage(wargameSchedule, "disabled")
    }), isCancelScheduleLoading = _e.isLoading, cancelSchedule = _e.mutate;
    var isAnyActionInProgress = isPauseScheduleLoading || isResumeScheduleLoading || isCancelScheduleLoading;
    var isFirstButtonPresent = [
        ScheduleStatus.scheduled,
        ScheduleStatus.paused
    ].includes(wargameSchedule.status);
    return (React.createElement(React.Fragment, null,
        wargameSchedule.status === ScheduleStatus.scheduled && (React.createElement(LoadingButton, { onClick: function () { return pauseSchedule(); }, isDisabled: isAnyActionInProgress, isLoading: isPauseScheduleLoading, iconBefore: React.createElement(VidPauseIcon, { label: "Pause" }) }, "Pause")),
        wargameSchedule.status === ScheduleStatus.paused && (React.createElement(LoadingButton, { onClick: function () { return resumeSchedule(); }, isDisabled: isAnyActionInProgress, isLoading: isResumeScheduleLoading, iconBefore: React.createElement(VidPlayIcon, { label: "Resume" }) }, "Resume")),
        isFirstButtonPresent && React.createElement(Separator, null),
        wargameSchedule.status !== ScheduleStatus.disabled && (React.createElement(LoadingButton, { onClick: function () { return cancelSchedule(); }, isDisabled: isAnyActionInProgress, isLoading: isCancelScheduleLoading, iconBefore: React.createElement(SelectClearIcon, { label: "Disable" }) }, "Disable"))));
}
var createSuccessMessage = function (wargameSchedule, action) {
    var _a;
    return "Schedule " + ((_a = wargameSchedule === null || wargameSchedule === void 0 ? void 0 : wargameSchedule.id) !== null && _a !== void 0 ? _a : "") + " is queued to be " + action + ". This usually takes upto 30 seconds";
};
